import { graphql } from 'src/graphql';

import { BookingFields } from 'src/fragments/bookingFields.fragment';
import { ManageBookingPageCalendar } from 'src/fragments/manageBookingPageCalendar.fragment';

export const RescheduleSessionLiveBooking = graphql(
  `
    mutation rescheduleSessionLiveBooking(
      $booking_id: ID!
      $session_id: ID!
      $newSession: BookingInputSession!
      $message: String
      $shouldMessage: Boolean
    ) {
      rescheduleSessionLiveBooking(
        booking_id: $booking_id
        session_id: $session_id
        newSession: $newSession
        message: $message
        shouldMessage: $shouldMessage
      ) {
        ...BookingFields
        ...ManageBookingPageCalendar
      }
    }
  `,
  [BookingFields, ManageBookingPageCalendar],
);
